import axios from "../../plugins/axios";

export const state = {
    filtros: null,
}

export const mutations = {
    SET_FILTROS(state, filtros) {
        state.filtros = filtros;
    },
}

export const getters = {
    getFiltros(state) {
        return state.filtros;
    },
}

export const actions = {
    listaSetupFazendas(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('fazenda-setup' + payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    createSetupFazenda(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('fazenda-setup', payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    payloadSetupFazenda(context, payload) {
        const account = JSON.parse(localStorage.getItem('account'));

        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('payload', payload.file);
            axios.post('fazenda-setup/payload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        });
    },
    updateSetupFazenda(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('fazenda-setup/' + payload.id, payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        })
    },
    showSetupFazenda(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('fazenda-setup/' + payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        })
    },
    adicionarAnoGeracao(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('fazenda-setup/' + payload.fazenda_id + '/adicionar-ano-geracao', payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                }
            )
        })
    },
    removerAnoFazenda(context,payload) {
        return new Promise((resolve, reject) => {
            axios.get('fazenda-setup/' + payload.id + '/remover-ano-fazenda')
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                }
            )
        })
    },
    atualizarMesGeracao(context, payload) {
    return new Promise((resolve, reject) => {
        axios.put('fazenda-setup/' + payload.id + '/atualizar-mes-geracao', payload)
            .then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            }
        )
    })
}
}



// WEBPACK FOOTER //
// ./src/store/modules/setupFazenda.js